import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations';

/**
 * Animation for expanding a list. We stagger each animation so the list appears to cascade down.
 */
export const expandListAnimation = trigger('expandList', [
	transition(
		'* <=> *',
		[
			style({ overflow: 'hidden' }),
			query(
				':enter',
				[
					style({ opacity: 0, transform: 'translateY(-15px)' }),
					stagger(
						`50ms`,
						animate('150ms {{delayEnter}}ms ease-out', style({ opacity: 1, transform: 'translateY(0px)' }))
					)
				],
				{ optional: true }
			)
		],
		{ params: { delayEnter: 0 } }
	)
]);

/**
 * Animation for expanding the list height. Every time the container height changes we need to animate from the
 * original container height to the new container height.
 */
export const expandListHeightAnimation = trigger('expandHeight', [
	state('void', style({ height: 0 })),
	transition(
		'* => void',
		[
			query(':self', [
				style({ height: '{{containerHeight}}px', opacity: 1 }),
				animate('250ms ease-out', style({ height: '0', opacity: 0 }))
			])
		],
		{ params: { heightSpeed: 0, containerHeight: 0 } }
	),
	transition(
		'* <=> *',
		[
			query(':self', [
				style({ height: '{{containerHeight}}px' }),
				animate('{{heightSpeed}}ms {{delayEnter}}ms', style({ height: '*' }))
			])
		],
		{ params: { heightSpeed: 0, containerHeight: 0, delayEnter: 0 } }
	)
]);
